import { RootState } from '../reducers';

const root = (state: RootState) => state.sharedComponents;

export default root;
